import React, { Component } from "react"
import { connect } from "react-redux"

import {
  setLockerToLokcerDeliveryRequest,
  logScreenEnterance,
  getAllDynamicProducts,
  resetLockersErrorsAttemptsOpened,
  LogoutUser,
  setRentalOrder,
  getOrdersRequests,
} from "../../../../../actions"
import WarningInfoModal from "../../../../Modals/WarningInfoModal"

import { FixedHeader } from "../../../../reduxified"
import { MenuOrangeButton, ScrollBoxWithTitle } from "../../../../common"
import Loader from "../../../../common/Loader"
import ItemRow from "./ItemRow"
import iconBoxBlack from "../../../../../assets/svg/icon_box_black.svg"
import "./style.css"

class LockerToLockerDeliveryMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showOutOfLockersModal: false,
      closedOrderSent: false,
      isMoreThanOneOrderWaitShow: false,
      openAttemptsNum: null,
    }
  }

  async componentDidMount() {
    this.props.logScreenEnterance("USER_LOCKER_DELIVERY_MENU_SCREEN")

    const { authenticated } = this.props
    if (!authenticated) {
      this.props.LogoutUser()
      this.props.history.push("")
    }
    const { userId, stationId } = this.props
    this.props.getOrdersRequests(stationId, userId, 5)
  }

  componentWillUpdate(newProps, nextState) {
    const {
      authenticated,
      isLoading,
      ordersRequestsList,
      isNoAvailableLockersForService,
    } = newProps

    if (!authenticated) {
      this.props.LogoutUser()
      this.props.history.push("")
    }
    if (isNoAvailableLockersForService) {
      this.setState({ showOutOfLockersModal: true })
      return
    }
    if (!isLoading && ordersRequestsList && ordersRequestsList.length === 0) {
      this.props.history.push("/LockerToLockerDeliveryScreen/SelectStation")
    }
  }

  onNewOrderClick() {
    const { isNoAvailableLockersForService } = this.props

    if (isNoAvailableLockersForService) {
      this.setState({ showOutOfLockersModal: true })
      return
    }
    this.props.history.push("/LockerToLockerDeliveryScreen/SelectStation")
  }

  onContinueRequestClick(request) {
    this.props.setLockerToLokcerDeliveryRequest(request)
    this.props.history.push("/LockerToLockerDeliveryScreen/PayOrder")
  }

  closeOutOfLockersModal() {
    this.setState({ showOutOfLockersModal: false })
  }

  renderLoader() {
    const { isLoading } = this.props
    if (!isLoading) {
      return <></>
    }
    return <Loader />
  }

  render() {
    const {
      all_lockers_full_err_title,
      all_lockers_full_err_body,
      close_text,
      firstName,
      hello_title_text,
      user_menu_what_sub_title_text,
      dirRtl,
      new_locker_to_locker_delivery,
      ordersRequestsList,
      isLoading,
      locker_to_locker_request_list_title,
      order_request_btn_text,
    } = this.props
    const { showOutOfLockersModal, openAttemptsNum } = this.state

    return (
      <div className="user-menu locker-to-locker-delivery">
        <FixedHeader buttonsFlag="userMenuScreen" />
        <div
          className="ums-title"
          dir={dirRtl ? "rtl" : "ltr"}
        >{`${hello_title_text}, ${firstName}`}</div>
        <div className="ums-subtitle" dir={dirRtl ? "rtl" : "ltr"}>
          {user_menu_what_sub_title_text}
        </div>

        <div className="ums-wrapper">
          <MenuOrangeButton onClick={() => this.onNewOrderClick()}>
            {new_locker_to_locker_delivery}
          </MenuOrangeButton>

          <ScrollBoxWithTitle
            title={locker_to_locker_request_list_title}
            dirRtl={dirRtl}
            show={
              !isLoading && ordersRequestsList && ordersRequestsList.length > 0
            }
            icon={iconBoxBlack}
          >
            {!isLoading &&
              ordersRequestsList.map((request) => {
                return (
                  <ItemRow
                    item={request}
                    onClick={(e) => this.onContinueRequestClick(request)}
                    btnText={order_request_btn_text}
                    dir={dirRtl ? "rtl" : "ltr"}
                  />
                )
              })}
          </ScrollBoxWithTitle>
          {this.renderLoader()}
        </div>

        <WarningInfoModal
          show={showOutOfLockersModal}
          title={all_lockers_full_err_title}
          text={all_lockers_full_err_body}
          onModalCloseClick={() => this.closeOutOfLockersModal()}
          btnText={close_text}
        />
      </div>
    )
  }
}

const mapStateToProps = ({
  userLogin,
  activeOrders,
  lockersCells,
  bgService,
  translate,
  lockerToLockerDelivery,
}) => {
  const { stationId } = bgService
  const { userId, role, authenticated, firstName } = userLogin
  const { displayedOrder } = activeOrders
  const {
    nextAllAvailableCells,
    errorLockersArr,
    openingAttempsMap,
    recentClosedLockersArr,
  } = lockersCells
  const {
    langName,
    dirRtl,
    user_menu_what_sub_title_text,
    user_menu_new_order_btn_text,
    close_text,
    user_menu_watch_orders_btn_text,
    user_menu_item_collection_btn_text,
    user_menu_product_purchase_btn_text,
    user_menu_driver_interface_btn_text,
    all_lockers_full_err_title,
    all_lockers_full_err_body,
    hello_title_text,
    see_you_again,
    new_locker_to_locker_delivery,
    locker_to_locker_request_list_title,
    order_request_btn_text,
  } = translate

  const hideCollectItemsBtn = !displayedOrder
  const hideDriverInterfaceBtn = role === "Customer" || role == null
  const isOutOfAvailableLockers =
    !nextAllAvailableCells || nextAllAvailableCells.length < 1

  const { isNoAvailableLockersForService, isLoading, ordersRequestsList } =
    lockerToLockerDelivery

  return {
    userId,
    dirRtl,
    role,
    authenticated,
    displayedOrder,
    hideCollectItemsBtn,
    hideDriverInterfaceBtn,
    isOutOfAvailableLockers,
    stationId,
    firstName,

    isNoAvailableLockersForService,
    isLoading,
    ordersRequestsList,

    langName,
    create_new_order: user_menu_new_order_btn_text,
    watch_order: user_menu_watch_orders_btn_text,
    collect_order: user_menu_item_collection_btn_text,
    purchase_products: user_menu_product_purchase_btn_text,
    driver_interface: user_menu_driver_interface_btn_text,
    all_lockers_full_err_title,
    close_text,
    all_lockers_full_err_body,
    hello_title_text,
    user_menu_what_sub_title_text,
    see_you_again,
    errorLockersArr,
    openingAttempsMap,
    recentClosedLockersArr,
    new_locker_to_locker_delivery,
    locker_to_locker_request_list_title,
    order_request_btn_text,
  }
}

export default connect(mapStateToProps, {
  setLockerToLokcerDeliveryRequest,
  logScreenEnterance,
  getAllDynamicProducts,
  resetLockersErrorsAttemptsOpened,
  LogoutUser,
  setRentalOrder,
  getOrdersRequests,
})(LockerToLockerDeliveryMenu)
